import type { SpotQuote } from '../../../api/src/lib/spot-shape'
// The spot-rate engine's answer for a lane, as stored in OUR database (migration 023) and read by the board.
// A Fly job asks the engine (10 to 60 s per question, key held only on Fly) for the lanes customers watch and
// refreshes them daily; the browser only tells us which lane it is looking at (watch_lane) and reads the stored
// quotes back (public_lane_spot). The shaping logic is shared with the REST route and the MCP tool: it lives in
// apps/api/src/lib/spot-shape.ts.
import { dataClient } from './supabase'

export * from '../../../api/src/lib/spot-shape'

export interface WatchState {
  state: 'queued' | 'watching' | 'capped' | 'invalid'
  fetched_at?: string | null
}

/** "I am looking at this lane": registers it so the job fetches it. Safe to repeat. Never throws. */
export async function watchLane(pol: string, pod: string): Promise<WatchState | null> {
  try {
    const { data, error } = await dataClient.rpc('watch_lane', { p_pol: pol, p_pod: pod })
    return error ? null : (data as WatchState)
  } catch {
    return null
  }
}

export async function getLaneSpot(pol: string, pod: string): Promise<SpotQuote[]> {
  const { data, error } = await dataClient.rpc('public_lane_spot', { p_pol: pol, p_pod: pod })
  if (error) throw error
  // numeric comes back as a string from some PostgREST setups; the board needs numbers.
  return ((data ?? []) as SpotQuote[]).map((q) => ({ ...q, amount: Number(q.amount) }))
}
